<template>
  <tr class="clinic-payment" style="vertical-align: middle">
    <td class="clinic-payment__date">{{ pretty_date }}</td>
    <td v-if="enable_payments_v2" class="clinic-payment__type">
      {{ pretty_acc_entry }}
    </td>
    <td class="clinic-payment__type">{{ pretty_type }}</td>
    <td class="clinic-payment__customer">
      <a class="btn-link" target="_blank" :href="customer_link">
        {{ customer ? customer.full_name : "PACIENTE BORRADO" }}</a>


      <i v-if="invoice_notes" class="fa fa-comment mx-1" data-toggle="tooltip" :title="invoice_notes">
      </i>
      <i v-if="customer.exclude_auto_invoice" class="fa fa-exclamation-circle mx-1" data-toggle="tooltip"
        title="Paciente excluido de la Facturación Automática, examinar su Ficha para más información"></i>
    </td>
    <td v-if="clinics && clinics.length > 1" class="clinic-payment__clinic">
      {{ clinic_name }}
    </td>

    <td v-if="invoices_enabled" class="clinic-payment__invoice">
      <a v-if="payment.invoice" class="btn-link" target="_blank" :href="invoice_link">{{ invoice_code }}</a>
      <button @click="emitInvoice" v-else class="btn btn-wabident-round">
        Facturar
      </button>
    </td>

    <td v-if="show_bank_order" class="clinic-payment__bankorder">
      <span v-if="!payment.bank_order_id">
        <span v-if="payment.import_code">
          Otro programa
        </span>
        <span v-else>
          Pendiente
        </span>
      </span>
      <span v-else>
        <strong>Remesa #{{ payment.bank_order_id }}</strong>
        <em v-if="payment.bank_order_payment_id">
          (Pagada)
        </em>
      </span>
    </td>

    <td class="clinic-payment__amount text-right">
      {{ pretty_amount }}
      <button @click="updatePayment" class="btn btn-wabident-round ml-2" style="font-size: 10px; padding: 5px 15px">
        <i class="fa fa-edit"></i>
      </button>
    </td>
  </tr>
</template>

<script>

export default {
  props: {
    payment: { required: true },
    clinics: { default: null },
    invoices_enabled: { default: false },
    show_bank_order: { default: false },
  },
  computed: {
    invoice_notes() {
      if (!this.payment || !this.payment.customer) {
        return null;
      }

      const notes = this.payment.customer.invoice_notes;
      if (notes && notes !== null) {
        return notes;
      }


      return null;
    },
    enable_payments_v2() {
      if (!this.clinic) return false;
      return this.clinic.config.enable_payments_v2;
    },
    customer_link() {
      if (this.customer) {
        return `/customer/${this.customer.id}/edit`;
      }
      return "";
    },
    customer() {
      return this.payment.customer;
    },
    pretty_date() {
      return moment(this.payment.created_at).format("DD/MM/YYYY");
    },
    pretty_acc_entry() {
      return (
        {
          deposit: "Depósito",
          assignment: "Asignación",
        }[this.payment.accounting_entry] || "N/D"
      );
    },
    pretty_type() {
      const t = this.payment.type;
      const st = this.payment.subtype;

      const typename = this.clinic.payment_types[t].name;

      if (!typename) {
        return '';
      }

      let ret = typename;
      const subtype = this.clinic.payment_types[t].subtypes[st];
      if (subtype) {
        ret = ret + ' - ' + subtype;
      }

      return ret;
    },
    pretty_amount() {
      return WabiDent.fmtMoney(this.payment.amount, 0);
    },
    clinic_name() {
      if (!this.clinics) return "";
      return this.clinics[this.payment.clinic_id] || "";
    },
    invoice_code() {
      if (!this.payment.invoice) return "";
      const code = this.payment.invoice.code;
      return code ? code : ('BORR' + this.payment.invoice.id);
    },
    invoice_link() {
      if (!this.payment.invoice) return "";
      return `/invoice/${this.payment.invoice.id}/pdf`;
    },
    ...mapGetters(["clinic"]),
  },
  methods: {
    emitInvoice() {
      this.$emit("invoice", this.payment);
    },
    updatePayment() {
      this.$emit("payment", this.payment);
    },
  },
};
</script>

<style lang="scss">
.clinic-payment {
  td {
    vertical-align: middle;
  }
}
</style>
